import { SingleDonation as SingleDonationForm } from "@bgea-js/form-templates";
import customConfirmationWGE from "../../../../src/content/wg-easter-devotional-donation/customConfirmation";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationWGE,
  React
};